/**
 * V5Shell: the layout route for the whole V5 experience.
 * Loader (first visit to "/" per session) → page transitions → chapter nav.
 */
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./v5.css";
import Loader from "./components/Loader";
import ChapterNav from "./components/ChapterNav";
import TransitionProvider from "./components/TransitionProvider";
import { useRevealAll } from "./lib/hooks";

const SEEN = "dbg-v5-loader-seen";
const seen = () => { try { return sessionStorage.getItem(SEEN) === "1"; } catch (_) { return false; } };

export default function V5Shell() {
  const { pathname } = useLocation();
  const [booting, setBooting] = useState(() => pathname === "/" && !seen());
  const [ready, setReady] = useState(!booting);

  // Paper behind the app so overscroll never flashes the legacy dark theme.
  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = "#F8F8F6";
    return () => { document.body.style.background = prev; };
  }, []);

  useEffect(() => { if (booting) window.scrollTo(0, 0); }, [booting]);

  useRevealAll(`${pathname}|${ready}`);

  const lift = () => { try { sessionStorage.setItem(SEEN, "1"); } catch (_) {} setReady(true); };
  const done = () => setBooting(false);

  return (
    <div className={`v5${ready ? "" : " is-booting"}`}>
      <TransitionProvider ready={ready}>
        {pathname !== "/" && <ChapterNav />}
        <main><Outlet /></main>
      </TransitionProvider>
      {booting && <Loader onLift={lift} onDone={done} />}
    </div>
  );
}
